"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Colors = require("../../00_environment/Colors");

var _Container = _interopRequireDefault(require("../../01_atoms/Container"));

var _CitySelectionWidget = _interopRequireDefault(require("../../02_molecules/CitySelectionWidget"));

var _DualPanePageWithSelector = _interopRequireDefault(require("../../02_molecules/DualPanePageWithSelector"));

var _HomeTopBar = _interopRequireDefault(require("../../02_molecules/HomeTopBar"));

var _BookingForm = _interopRequireDefault(require("../../02_molecules/BookingForm"));

var _DateSelectionWidget = _interopRequireDefault(require("../../02_molecules/DateSelectionWidget"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var DualPaneBookingFormPage = function DualPaneBookingFormPage(_ref) {
  var formFields = _ref.formFields,
      _onChange = _ref.onChange,
      onSubmit = _ref.onSubmit,
      translationManager = _ref.translationManager,
      translatorForNamespace = _ref.translatorForNamespace,
      dropDownSearch = _ref.dropDownSearch,
      departures = _ref.departures,
      arrivals = _ref.arrivals,
      t = _ref.t,
      minDepartureDay = _ref.minDepartureDay,
      minReturnDay = _ref.minReturnDay,
      maxBookingDay = _ref.maxBookingDay,
      disableReturnField = _ref.disableReturnField;
  var selectedDeparture = formFields.selectedDeparture,
      selectedArrival = formFields.selectedArrival,
      outDate = formFields.outDate,
      returnDate = formFields.returnDate;
  var rightComponentByName = {
    'origin-selector': function originSelector(_ref2) {
      var scrollTop = _ref2.scrollTop,
          showOnRight = _ref2.showOnRight,
          _ref2$focusedLeftItem = _ref2.focusedLeftItemId,
          focusedLeftItemId = _ref2$focusedLeftItem === void 0 ? null : _ref2$focusedLeftItem;
      return /*#__PURE__*/_react["default"].createElement(_CitySelectionWidget["default"], _extends({
        title: t('Select a departure terminal'),
        items: departures,
        selectedItem: selectedDeparture,
        onSelect: function onSelect(s) {
          showOnRight(null);

          _onChange({
            selectedDeparture: s
          });
        },
        elementStyle: {},
        translator: t,
        focusedLeftItemId: focusedLeftItemId
      }, {
        scrollTop: scrollTop
      }));
    },
    'destination-selector': function destinationSelector(_ref3) {
      var scrollTop = _ref3.scrollTop,
          showOnRight = _ref3.showOnRight,
          _ref3$focusedLeftItem = _ref3.focusedLeftItemId,
          focusedLeftItemId = _ref3$focusedLeftItem === void 0 ? null : _ref3$focusedLeftItem;
      return /*#__PURE__*/_react["default"].createElement(_CitySelectionWidget["default"], _extends({
        title: t('Select a destination terminal'),
        items: arrivals,
        selectedItem: selectedArrival,
        onSelect: function onSelect(s) {
          showOnRight(null);

          _onChange({
            selectedArrival: s
          });
        },
        elementStyle: {},
        translator: t,
        focusedLeftItemId: focusedLeftItemId
      }, {
        scrollTop: scrollTop
      }));
    },
    'outbound-date-selector': function outboundDateSelector(_ref4) {
      var scrollTop = _ref4.scrollTop,
          showOnRight = _ref4.showOnRight,
          _ref4$focusedLeftItem = _ref4.focusedLeftItemId,
          focusedLeftItemId = _ref4$focusedLeftItem === void 0 ? null : _ref4$focusedLeftItem;
      return /*#__PURE__*/_react["default"].createElement(_DateSelectionWidget["default"], {
        title: t('Departure date'),
        selectedDay: outDate,
        minDay: minDepartureDay,
        maxDay: maxBookingDay,
        onChange: function onChange(d) {
          showOnRight(null);

          _onChange({
            outDate: d
          });
        },
        translationManager: translationManager,
        focusedLeftItemId: focusedLeftItemId,
        scrollTop: scrollTop
      });
    },
    'return-date-selector': function returnDateSelector(_ref5) {
      var scrollTop = _ref5.scrollTop,
          showOnRight = _ref5.showOnRight,
          _ref5$focusedLeftItem = _ref5.focusedLeftItemId,
          focusedLeftItemId = _ref5$focusedLeftItem === void 0 ? null : _ref5$focusedLeftItem;
      return /*#__PURE__*/_react["default"].createElement(_DateSelectionWidget["default"], {
        title: t('Return date'),
        selectedDay: returnDate,
        minDay: minReturnDay,
        maxDay: maxBookingDay,
        onChange: function onChange(d) {
          showOnRight(null);

          _onChange({
            returnDate: d
          });
        },
        translationManager: translationManager,
        focusedLeftItemId: focusedLeftItemId,
        scrollTop: scrollTop
      });
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_HomeTopBar["default"], {
    translatorForNamespace: translatorForNamespace
  }), /*#__PURE__*/_react["default"].createElement(_DualPanePageWithSelector["default"], {
    leftComponent: function leftComponent(_ref6) {
      var showOnRight = _ref6.showOnRight;
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          backgroundColor: _Colors.topBarBgColor,
          paddingTop: 20,
          paddingBottom: 30
        }
      }, /*#__PURE__*/_react["default"].createElement(_Container["default"], null, /*#__PURE__*/_react["default"].createElement(_BookingForm["default"], {
        formData: formFields,
        onChange: _onChange,
        onSubmit: onSubmit,
        translationManager: translationManager,
        translator: t,
        dropDownSearch: dropDownSearch,
        departures: departures,
        arrivals: arrivals,
        dualPaneMode: true,
        onOriginFieldFocus: function onOriginFieldFocus(id) {
          return showOnRight('origin-selector', id);
        },
        onDestinationFieldFocus: function onDestinationFieldFocus(id) {
          return showOnRight('destination-selector', id);
        },
        onOutboundDateFieldFocus: function onOutboundDateFieldFocus(id) {
          return showOnRight('outbound-date-selector', id);
        },
        onReturnDateFieldFocus: function onReturnDateFieldFocus(id) {
          return showOnRight('return-date-selector', id);
        },
        onFieldClear: function onFieldClear() {
          return showOnRight(null);
        },
        disableReturnField: disableReturnField
      })));
    },
    rightComponentByName: rightComponentByName
  }));
};

var _default = DualPaneBookingFormPage;
exports["default"] = _default;